export enum RfrrPageNamespace {
  Infosite = 'HOT.HIS',
  Search = 'HOT.SR'
}
